import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import { sync } from 'vuex-router-sync'
import VueNumber from 'vue-number-animation'
import vuetify from './plugins/vuetify';
import i18n from './i18n'

Vue.use(VueNumber);
Vue.config.productionTip = false
Vue.config.devtools = true

sync(store, router) // done. Returns an unsync callback fn

let mixin = {
  methods: {
    notEmptyObject(someObject){
      return Object.keys(someObject).length
    },
    // Takes an array of objects and the property by which they should be grouped.
    // Produces an object of arrays keyed by the specified property values.
    //
    // Provide multiple keys if your data is nested:   groupBy(dogs, 'values', 'emoji')
    //
    // Ex: [{id: 1, group: 'A'}, {id: 2, group: 'B'}, {id: 3, group: 'A'}],   'group'
    //     =>
    //     {A: [{id: 1, group: 'A'}, {id: 3, group: 'A'}], B: [{id: 2, group: 'B'}]}
    groupBy(data, ...keys)
    {
      // Ex: {values: {color: 'red'}}, ['values', 'color'] => 'red'
      const getGroupFromItem = (item, keys) =>
      {
        return (keys.length > 1)
          ? getGroupFromItem(item[keys[0]], keys.slice(1))
          : item[keys[0]]
      }

      return data.reduce((results, item) =>
        {
          // Get the first instance of the key by which we're grouping
          var group = getGroupFromItem(item, keys);

          // Ensure that there's an array to hold our results for this group
          results[group] = results[group] || [];

          // Add this item to the appropriate group within results
          results[group].push(item);

          // Return the updated results object to be passed into next reduce call
          return results;
        },

        // Initial value of the results object
        {}
      );
    }
  }
}

export const vm = new Vue({
  router,
  store,
  vuetify,
  mixins: [mixin],
  i18n,
  render: h => h(App)
}).$mount('#decoupled-page-root')




